<template>
  <div class="logo">
    <router-link :to="{name:'dashboard'}">
      <img class="imgborder" src="../../assets/logo.png" style="width:40px;height:40px;"/>
      <h1 v-if="showTitle">{{ appName }}</h1>
    </router-link>
  </div>
</template>

<script>
import appConfig from '@/config/app.config.js'

export default {
  name: 'Logo',
  props: {
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data () {
    return {
      appName: appConfig.appName
    }
  }
}
</script>

<style scoped>
.imgborder{
  border-radius: 7px
}
</style>
